import Backbone from 'backbone';
import _ from 'underscore';
import tmpl from '@bingads-webui-campaign-legacy/auto-targets/template/create/mixedSpecificWebPage.pug';

import SpecificTargetView from '@bingads-webui-campaign-legacy/auto-targets/view/create/specificWebPageWithoutPreview';
import ExactURLsView from '@bingads-webui-campaign-legacy/auto-targets/view/create/exactURLs';
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class View extends Backbone.View {
  initialize() {
    this.defaultTarget = 'exacturls';
  }

  render() {

    this.$el.html(tmpl({
      i18n,
    }));

    this.viewSelection = [
      {
        name: 'specificpage',
        instance: new SpecificTargetView({
          setting: this.options.setting,
          el: this.$('.rules-container'),
          shouldCheckArgumentOperandFormat: this.options.shouldCheckArgumentOperandFormat,
          isShowUrlOnly: this.options.isShowUrlOnly,
          isExclude: this.options.isExclude,
        }).render(),
      },
      {
        name: 'exacturls',
        instance: new ExactURLsView({
          el: this.$('.exacturls-container'),
          isExclude: this.options.isExclude,
        }).render(),
      },
    ];

    this.toggleTarget(this.defaultTarget);
    this.on('update:selecttarget', (target) => {
      this.toggleTarget(target);
    });

    _.each(this.viewSelection, (view) => {
      view.instance.on({
        'selectTarget': (target) => {
          this.trigger('selectTarget', target);
        },
      });
    });

    this.on('update:setting', (setting) => {
      _.each(this.viewSelection, (view) => {
        view.instance.trigger('update:setting', setting);
      });
    });

    this.on('update:items', (items) => {
      _.each(this.viewSelection, (view) => {
        view.instance.trigger('update:items', items);
      });
    });

    return this;
  }

  toggleTarget(target) {
    _.each(this.viewSelection, (view) => {
      if (view.name === target) {
        view.instance.show();
      } else {
        view.instance.hide();
      }
    });
  }

  show() {
    this.$el.show();
    return this;
  }

  hide() {
    this.$el.hide();
    return this;
  }

  reset(selectedType) {
    _.each(this.viewSelection, (view) => {
      if (view.name === selectedType) {
        view.instance.reset();
      }
    });
  }
}
